import { render, staticRenderFns } from "./MeetingSimpleCardMobile.vue?vue&type=template&id=f0480912&scoped=true"
import script from "./MeetingSimpleCardMobile.vue?vue&type=script&lang=js"
export * from "./MeetingSimpleCardMobile.vue?vue&type=script&lang=js"
import style0 from "./MeetingSimpleCardMobile.vue?vue&type=style&index=0&id=f0480912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0480912",
  null
  
)

export default component.exports